import React from 'react';
import { useResetAtom } from 'jotai/utils';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { Button, Stack, Typography } from '@mui/material';
import { translateThis } from '../../helpers/language.helper';
import AppIcons from '../../assets/images/icons/index';
import AppLayout from '../../layouts/app/AppLayout';
import SVGIcons from '../../assets/images/icons/svgIcons';

import './auth.scss';
import LoginForm from '../../forms/login.form';
import { authState } from '../../state/auth.state';
import { USER_ROLES } from '../../constants';



const LoginPage = () => {
    const pageName = 'Login';
    const [auth, setAuth] = useAtom(authState);
    const reset = useResetAtom(authState);

    const navigate = useNavigate();
    const location = useLocation();
    const isAuth = auth.isLoggedIn;
    const { from } = location.state || { from: { pathname: `/` } };
    if (isAuth) {
        // navigate(from, { replace: true });
    }

    /**
     * Updates the state 
     * @param {string} key 
     * @param {string} val 
     */
    const updateState = (key, val) => {
        setAuth((prv) => ({ ...prv, [key]: val }))
    }
    return (
        <AppLayout
            pageName={pageName}
            isLoadHeader={false}
            isLoadFooter={false}
            bodyClassName='login-wrp auth-layout'
        >
            <div className='auth-page-layout f-wrp'>
                <div className='main-container-wrp'>

                    <div className='flex-box'>
                        <div className='form-sec-wrp'>
                            {auth.userRole ? <div className="back-btn-wrp">
                                <Button onClick={reset} ><SVGIcons.LearnMoreArrow /></Button>
                            </div> : null}
                            {auth.userRole ? <>
                                <Link to={'/'} className='auth-logo'><img src={AppIcons.BlueLogo} alt='WDP' /></Link>
                                <div className='auth-form'>
                                    <LoginForm />
                                </div></> : <div className='auth-form'>
                                <Stack className='form-tile'>
                                    <Typography variant="h1" fontStyle={'normal'} fontWeight={'300'}>{translateThis('Tell us who you are')}</Typography>
                                </Stack>
                                <div className='user-type-wrp f-wrp'>
                                    <Link to={'#'} onClick={() => updateState('userRole', USER_ROLES.member)} className='each-user-box f-wrp'>
                                        <p><b>{translateThis('Member')}</b></p>
                                        <SVGIcons.MemberIcon />
                                    </Link>
                                    <Link to={'#'} onClick={() => updateState('userRole', USER_ROLES.volunteer)} className='each-user-box f-wrp'>
                                        <p><b>{translateThis('Volunteer')}</b></p>
                                        <SVGIcons.VolunteerIcon />
                                    </Link>
                                    <Link to={'#'} onClick={() => updateState('userRole', USER_ROLES.staff)} className='each-user-box f-wrp'>
                                        <p><b>{translateThis('Staff')}</b></p>
                                        <SVGIcons.StaffIcon />
                                    </Link>
                                </div>
                            </div>}
                        </div>
                        <div className='form-img-wrp'>
                            <span><img src={AppIcons.loginBG} alt='login' /></span>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default LoginPage;